export default __webpack_public_path__ + "img/tiny-27.642f20ee.jpg";